module.exports = __webpack_public_path__ + "static/media/338.3ab18381.svg";